import { useSelector } from 'react-redux'
import { RootState } from 'store'

// Idea: probably better to get rid of role checks completely and move logic into permissions
export enum UseRoles {
  SuperAdmin = 1,
  SuperUser = 2,
  BusinessOwner = 3,
  Administrator = 4,
  MasterBlender = 5,
  RegularUser = 6,
  BasicUser = 7,
  MasterFlour = 8,
  RegularBakerUser = 9,
}

export const useRoles = () => {
  const userProfile = useSelector((state: RootState) => state.user.profile)

  const isSuperAdmin = userProfile?.role?.id === UseRoles.SuperAdmin
  const isSuperUser = userProfile?.role?.id === UseRoles.SuperUser
  const isSpecificRole = (role: UseRoles) => userProfile?.role?.id === role

  return { isSuperAdmin, isSuperUser, isSpecificRole }
}
